/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Policy_Destructive_Confirm_EmptyInputs */



/**
* | output |
* | --- |
* | "No agent is marked for irreversible actions yet. After you switch this on, an agent's creator can mark a private agent, and an administrator a shared one." |
*
* @param {Agent_Policy_Destructive_Confirm_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_policy_destructive_confirm_empty = /** @type {((inputs?: Agent_Policy_Destructive_Confirm_EmptyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Policy_Destructive_Confirm_EmptyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch ist kein Agent für unumkehrbare Aktionen markiert. Nach dem Aktivieren kann die Erstellerin oder der Ersteller einen privaten Agenten markieren, eine Administratorin oder ein Administrator einen geteilten.")
	return /** @type {LocalizedString} */ ("No agent is marked for irreversible actions yet. After you switch this on, an agent's creator can mark a private agent, and an administrator a shared one.")
});